module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Plus-5d48b3839ef3a692d330a33a639b0094dccda1c06b91881d5071237441645c38.svg";